/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ folderName: NonNullable<unknown> }} Coinvestments_Dataroom_Collapsefolder3Inputs */

const en_coinvestments_dataroom_collapsefolder3 = /** @type {(inputs: Coinvestments_Dataroom_Collapsefolder3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Collapse ${i?.folderName}`)
};

/**
* | output |
* | --- |
* | "Collapse {folderName}" |
*
* @param {Coinvestments_Dataroom_Collapsefolder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_collapsefolder3 = /** @type {((inputs: Coinvestments_Dataroom_Collapsefolder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Collapsefolder3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_collapsefolder3(inputs)
});
export { coinvestments_dataroom_collapsefolder3 as "coInvestments_dataRoom_collapseFolder" }